import { Typography } from "antd"
import { useTranslation } from "react-i18next"

export const ColumnName= ({name})=>{
    const {t}= useTranslation()
    return (
        <Typography.Text strong>{t(name)}</Typography.Text>
    )
}